<template>
  <div class="container mx-auto">
    <div class="flex justify-center">
      <div class="text-sm  pt-6 pb-5">{{title}}</div>
    </div>
    <div class="flex justify-center">
      <h1 class="text-3xl pb-6">集計中</h1>
    </div>
    <hr>
    <div class="flex flex-col h-80">
      <div class="pt-10 px-10">
        <div class="bg-yellow-100 rounded-b text-yellow-900 mx-5 mb-10 px-4 py-3" role="alert">
          <div class="flex">
            <div class="py-1"><svg class="fill-current h-6 w-6 text-yellow-700 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/></svg></div>
            <div>
              <p class="text-xs text-yellow-600 inline-block align-baseline">終了のお知らせがありましたら、再度更新をお願いします。</p>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-center p-3">
        <button class="w-16 h-16  bg-blue-400 text-sm text-white font-semibold rounded-full hover:bg-blue-500" @click="$emit('reload')">更新する</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: '' }
  },
  emits: ['reload'],
}
</script>